import axios from "axios";
import store from '@/state/store'

export async function downloadFile(uri, fileName){
    let ext = uri.split('.')
    ext = ext[ext.length-1]

    return axios({
        url: process.env.VUE_APP_API_URL + 'getFile',
        method: 'GET',
        params:{
            path: uri
        },
        headers:{
            common:{
                'Authorization': 'Bearer ' + store.getters['auth/getToken']
            }
        },
        responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
  
            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileName+'.'+ext);
            document.body.appendChild(fileLink);
  
            fileLink.click();
            return Promise.resolve(true)
    }).catch((error)=>{
        alert(error)
        return error;
    })
}